<template>
  <div class="filter__searchbar">
    <input
      type="text"
      ref="searchbar"
      class="searchbar"
      :value="searchValue"
      @input="$emit('input', $event.target.value)"
      placeholder="Rechercher une entreprise"
    />
  </div>
</template>

<script>
export default {
  props: ["searchValue"],
};
</script>

<style lang="scss" scoped>
.filter__searchbar {
  margin-bottom: 10px;
  .searchbar {
    display: block;
    width: 100%;
    margin: 0;
    padding: 15px 20px;
    padding-left: 50px;
    color: var(--black);
    font-size: 14px;
    font-weight: 500;
    line-height: 22.4px;
    border: 1px solid var(--lightGray);
    border-radius: 5px;
    background-color: var(--white);
    outline: none;
    background-image: url("../assets/images/icons/icon-search.svg");
    background-repeat: no-repeat;
    background-position: 20px center;
    background-size: 15px auto;
    &::placeholder {
      color: var(--black);
      opacity: 0.5;
    }
    &:focus {
      border: 1px solid var(--green);
    }
  }
}
</style>
